import { render, staticRenderFns } from "./DeleteCampaignPopup.vue?vue&type=template&id=a4cb86a4&scoped=true&"
import script from "./DeleteCampaignPopup.vue?vue&type=script&lang=js&"
export * from "./DeleteCampaignPopup.vue?vue&type=script&lang=js&"
import style0 from "./DeleteCampaignPopup.vue?vue&type=style&index=0&id=a4cb86a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cb86a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4cb86a4')) {
      api.createRecord('a4cb86a4', component.options)
    } else {
      api.reload('a4cb86a4', component.options)
    }
    module.hot.accept("./DeleteCampaignPopup.vue?vue&type=template&id=a4cb86a4&scoped=true&", function () {
      api.rerender('a4cb86a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/DeleteCampaignPopup.vue"
export default component.exports